<template>
  <div class="contenedor-cpanel">
    <BaseNotification2
      v-if="store.status.msg != null"
      :type="store.status.type"
      :text="store.status.msg"
      :closable="store.status.closable"
      @close="borrarNotificacion()"
    />
    <div class="contenedor-titulo">
      <h1>Mesas De Examenes</h1>
      <div class="barra"></div>
    </div>
    <div class="contenedor_botones_cpanel">
        <router-link to="/mesa-examen-noviembre-2025" class="botones_cpanel">Noviembre 2025</router-link>
      </div>
  </div>
</template>

<script>
import store from '../store'
import BaseNotification2 from '../components/BaseNotification2'
export default {
  name: 'MesasDeExamenes',
  components: {
    BaseNotification2
  },
  data: function () {
    return {
      store
    }
  },
  methods: {
    borrarNotificacion () {
      this.store.setStatus({
        msg: null,
        type: null,
        title: null
      })
    }
  },
  mounted: function () {
    setTimeout(() => {
      this.borrarNotificacion()
    }, 4000)
  }
}
</script>

<style>

</style>
